/**
 * RouterNode - Forwards input events to output unchanged.
 * Useful for routing events through encapsulated sub-graphs.
 */

import { BaseNode } from '@nodes/BaseNode';
import { Domain } from '@nodes/Endpoint';
import { events, params } from '@nodes/TypedEndpoints';
import type { Payload } from '@graph/Payload';
import type { Dependencies } from '@nodes/Dependencies';
import type { NodeDef } from '@runtime/IRuntime';

const endpoints = params({
  routing: { isInput: true, isOutput: true,  custom: true }
});

class RouterNode extends BaseNode<typeof endpoints> {
  constructor(id: string, deps: Dependencies) {
    super(id, deps);
  }

  onParamChanged(payload: Payload, endpointId: string): void {
    (this.params as any)[endpointId].set(payload);
  }
}

export const routerNodeDef: NodeDef<RouterNode> = {
  type: 'Router',
  shortName: 'route',
  info: 'Pass-through node for routing values across sub-graph boundaries. Add custom params to define the interface.',
  domain: Domain.Data,
  endpoints,
  allowAddParam: true,
  ctor: RouterNode
};
